import GuestHomepage from './GuestHomepage';

export default GuestHomepage;
